import get from 'lodash/get';

/**
 * Replaces {{path.to.value}} placeholders in a string with values from rootData.
 * Paths are resolved as absolute dot-notation paths from the root data object.
 *
 * Example: prop "/segment?sourceLocation={{sourceSegment.location}}"
 * resolves {{sourceSegment.location}} → rootData.sourceSegment.location
 */
export function interpolateData(prop: string, rootData: Record<string, unknown>): string {
  return prop.replace(/\{\{([^}]+)\}\}/g, (_, key: string) => {
    const value = get(rootData, key);
    if (value !== null && value !== undefined) return String(value);
    return '';
  });
}
